import React from 'react';
import { dayjs } from '../support/helpers/dayjs.ts';
import { IonText } from '@ionic/react';
import { useInstance } from '../support/ioc/useInstance';
import { useSubscription } from '@autopylot-internal/state';
import { Card } from '../components/card/Card.tsx';
import { CardHeader } from '../components/card/CardHeader.tsx';
import { CardContent } from '../components/card/CardContent.tsx';
import { Spinner } from '../components/spinner/Spinner.tsx';
import { formatLogDateAndTime, initCap } from '../support/helpers/format.ts';
import { ButtonBar } from '../components/button/ButtonBar.tsx';
import { Button } from '../components/button/Button.tsx';
import { HistoryViewModel } from '../app/HistoryViewModel.ts';
import { AircraftLogState } from './AircraftLogState.tsx';

export const AircraftLogCard: React.FC<{aircraftId: string}> = ({ aircraftId }) => {
    const history = useInstance(HistoryViewModel);

    const logState = useInstance(AircraftLogState);
    useSubscription(() => logState);

    // get last 3 entries from the past
    const recentLogEntries = logState.getEntries(aircraftId)?.filter(e => dayjs().isAfter(e.dateTime)).slice(0, 3);

    const viewLog = async () => {
        history.push(`/fleet/${aircraftId}/log`);
    };

    const addEntry = async () => {
        history.push(`/fleet/${aircraftId}/log/add?backTo=/fleet/${aircraftId}/log`);
    };

    return (
        <Card>
            <CardHeader>
                <span style={{fontSize: 16, fontWeight: 'bold'}}>Drone Log</span>
            </CardHeader>
            <CardContent>
                {!recentLogEntries ? (
                    <div style={{textAlign: 'center'}}>
                        <Spinner size="small" />
                    </div>
                ) : (
                    <>
                        {!recentLogEntries.length ? (
                            <>
                                <IonText color="medium">
                                    No entries yet, start tracking Maintenance, Incidents, and more!
                                </IonText>

                                <div style={{marginTop: 12, textAlign: 'center'}}>
                                    <Button size="medium" onClick={addEntry}>New Entry</Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div style={{display: 'grid', gridTemplateColumns: '75px auto 100px', gap: 8, marginRight: -8}}>
                                    <IonText style={{fontSize: 12}} color="medium"><b>Date</b></IonText>
                                    <IonText style={{fontSize: 12}} color="medium"><b>Title</b></IonText>
                                    <IonText style={{fontSize: 12}} color="medium"><b>Type</b></IonText>
                                    {recentLogEntries?.map(entry => (
                                        <React.Fragment key={entry.id}>
                                            <span>{formatLogDateAndTime(entry.dateTime)}</span>
                                            <span style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{entry.title}</span>
                                            <span>{initCap(entry.type)}</span>
                                        </React.Fragment>
                                    ))}
                                </div>

                                <div style={{marginTop: 20}}>
                                    <ButtonBar>
                                        <Button expand="block" size="medium" fill="outline" onClick={viewLog}>View All</Button>
                                        <Button expand="block" size="medium" onClick={addEntry}>New Entry</Button>
                                    </ButtonBar>
                                </div>
                            </>
                        )}
                    </>
                )}
            </CardContent>
        </Card>

    );
};
